type Props = {
    value: number | string,
};

/**
 * @param {number|string} props.value - input value
 * @return {string} - input value string values.
 * Return 'Yes' for no string true values and 'No' for no string false values.
 * @example
 * //returns 'title'
 * formatYesNo({value: 'title'});
 *
 * //returns 'Yes'
 * formatYesNo({value: 1});
 *
 * //returns 'No'
 * formatYesNo({value: false});
 */
export const formatYesNo = (props: Props): string | 'Yes' | 'No' => {
    const {value} = props;

    if (typeof value === 'string') {
        return value;
    }

    return value ? 'Yes' : 'No';
};
